/* eslint-disable indent */
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax'

export class DashboardController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/dashboard')
    }

    dashboardy(owner:ISupportSpinner, success:{(res:string):any}, error?:AjaxError) {
        super._call('get', 'dashboardy', owner, null, null, success, error, 'text')
    }

    getProgramSelectionPageInfo(owner:ISupportSpinner, success:{(res:string):any}, error?:AjaxError) {
        super._call('get', 'GetProgramSelectionPageInfo', owner, null, null, success, error, 'text')
    }
}
